import React from 'react'
import { css } from '@linaria/core'
import { NoticeLoading } from '@fs/zion-icon'

const center = css`
  min-height: 30vh;
  display: flex;
  align-items: center;
  justify-content: center;
`

export default function LoadingSpinner() {
  return (
    <div data-testid="spinner" className={center}>
      <NoticeLoading size="lg" />
    </div>
  )
}
